import React from 'react';
import styles from '../LandingPage.module.css';

const WhyIndiaSection = () => {
  const benefits = [
    'Access to highly skilled talent',
    'Cost-efficient operations',
    'Strong technology ecosystem',
    'AI and digital innovation expertise',
    'Scalability for global growth'
  ];

  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px' }}>
        <div className={styles.pillLight}>🔹 Why India</div>
        <h2 className={styles.sectionTitleLight}>India: the preferred destination for<br/>Global Capability Centers</h2>
        <p className={styles.sectionSubtitleLight}>Build globally. Operate intelligently. Scale confidently.</p>
        
        <div style={{ display: 'flex', gap: '40px', marginTop: '40px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 400px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '24px', minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
             <div style={{ position: 'absolute', top: '20px', left: '20px', fontSize: '0.75rem', fontWeight: 600, color: '#3b82f6', letterSpacing: '1px' }}>INDIA GCC HUB</div>
             {/* Map Placeholder */}
             <div style={{ width: '200px', height: '100px', borderBottom: '2px solid #bae6fd', borderRadius: '50%', transform: 'rotateX(60deg)', position: 'relative' }}>
                <div style={{ width: '20px', height: '20px', background: '#8b5cf6', borderRadius: '50%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', boxShadow: '0 0 20px #8b5cf6' }}></div>
             </div>
          </div>
          
          <div style={{ flex: '1 1 400px', display: 'flex', flexDirection: 'column', gap: '16px', justifyContent: 'center' }}>
            {benefits.map((benefit, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px 24px', border: '1px solid #e2e8f0', borderRadius: '12px', background: '#ffffff', boxShadow: '0 4px 6px rgba(0,0,0,0.02)' }}>
                <span style={{ color: '#3b82f6', fontSize: '1.25rem' }}>✓</span>
                <span style={{ color: '#334155', fontWeight: 500 }}>{benefit}</span>
              </div>
            ))}
            <div style={{ marginTop: '8px', padding: '16px 24px', border: '1px solid #3b82f6', borderRadius: '12px', background: '#eff6ff', color: '#1e40af', fontWeight: 600 }}>
              Build globally. Operate intelligently. <span style={{ textDecoration: 'underline' }}>Scale confidently.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyIndiaSection;
